import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth-context";
import { AdminTabs } from "../components/admin/AdminTabs";

export default function AdminEnquiries() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/enquiries");
        setItems(data);
      } catch (err) {
        setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div data-testid="admin-enquiries-page" className="container-ccc py-12">
      <div className="eyebrow">Admin · {user?.email}</div>
      <h1 className="font-serif text-4xl mt-2">Enquiries</h1>
      <AdminTabs active="/admin/enquiries" />
      <p className="mt-3 text-ink-muted">Most recent enquiries from the public website.</p>

      {loading && <div className="mt-10 text-ink-muted">Loading…</div>}
      {error && <div className="mt-10 text-destructive text-sm">{error}</div>}
      {!loading && !error && items.length === 0 && (
        <div className="mt-10 p-8 bg-white border border-stone-200/60 rounded-md text-ink-muted">No enquiries yet.</div>
      )}

      <div className="mt-10 space-y-4">
        {items.map((e) => (
          <div key={e.id} data-testid={`admin-enquiry-${e.id}`} className="p-6 bg-white border border-stone-200/60 rounded-md">
            <div className="flex flex-wrap justify-between gap-3">
              <div>
                <div className="font-serif text-2xl">{e.full_name}</div>
                <div className="text-sm text-ink-muted">{e.email} · {e.phone}</div>
              </div>
              <div className="text-xs uppercase tracking-widest text-bronze-dark">{e.payment_type}{e.insurance_provider ? ` · ${e.insurance_provider}` : ""}</div>
            </div>
            <div className="mt-4 text-sm text-ink-muted whitespace-pre-wrap">{e.reason}</div>
            <div className="mt-4 flex flex-wrap gap-x-6 gap-y-1 text-xs text-ink-muted">
              <span>Consultant: <b>{e.preferred_consultant || "Any"}</b></span>
              <span>Times: <b>{e.preferred_times || "—"}</b></span>
              <span>DOB: <b>{e.date_of_birth || "—"}</b></span>
              <span>Received: <b>{new Date(e.created_at).toLocaleString()}</b></span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
